function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix_basic_logo{fill:#020203}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  id: "prefix__Ellipse_11",
  cx: 2.275,
  cy: 2.275,
  r: 2.275,
  className: "prefix_basic_logo",
  "data-name": "Ellipse 11",
  transform: "translate(17.672 14.55)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "prefix__Path_18",
  d: "M-453.7-225.635a20 20 0 0 1-20 19.736 19.984 19.984 0 0 1-20-20 19.984 19.984 0 0 1 20-20 20 20 0 0 1 20 19.365l-7.937-4.709a13.247 13.247 0 0 0-12.116-7.884A13.232 13.232 0 0 0-486.98-225.9a13.232 13.232 0 0 0 13.228 13.228 13.32 13.32 0 0 0 11.8-7.249h-2.116a5.691 5.691 0 0 1-5.714-5.714h16.082z",
  className: "prefix_basic_logo",
  "data-name": "Path 18",
  transform: "translate(493.7 245.9)"
});

var SvgGorrionLogoBasic = function SvgGorrionLogoBasic(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "prefix__gorrion_logo_podstawowe",
    transform: "translate(493.7 245.9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_122",
    "data-name": "Group 122",
    transform: "translate(-493.7 -245.9)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_10",
    cx: 2.275,
    cy: 2.275,
    r: 2.275,
    "data-name": "Ellipse 10",
    transform: "translate(17.672 14.55)",
    style: {
      fill: "none",
      stroke: "#020203",
      strokeMiterlimit: 10
    }
  }), _ref3, _ref4)));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGorrionLogoBasic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gorrion_logo_basic.6109c754.svg";
export { ForwardRef as ReactComponent };